import { useI18n } from "../lib/i18n";

/**
 * PLAYER-FACING FAQ. Deliberately contains no credit prices, streamer terms,
 * or pricing tiers. The streamer question only points them behind login +
 * verification. All strings live in the central i18n T object.
 */
const QUESTIONS = [
  "q1", "q2", "q3", "q4", "q5", "q6", "q7", "q8",
  "q9", "q10", "q11", "q12", "q13", "q14", "q15",
];

export default function FAQ() {
  const { t } = useI18n();
  return (
    <article className="max-w-3xl mx-auto px-6 py-16 lg:py-20">
      <div className="font-mono text-[11px] uppercase tracking-widest text-[#2DD4A7] mb-3">FAQ</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-4" data-testid="faq-title">{t("faq.title")}</h1>
      <p className="text-sm text-[#8B97AE] leading-relaxed mb-10">{t("faq.intro")}</p>
      <div className="space-y-8">
        {QUESTIONS.map((q) => (
          <section key={q} data-testid={`faq-${q}`} className="border-l-2 border-[#2DD4A7]/30 pl-4">
            <h2 className="font-display text-lg font-bold text-[#E8ECF4] mb-2">{t(`faq.${q}.q`)}</h2>
            <p className="text-sm text-[#8B97AE] leading-relaxed">{t(`faq.${q}.a`)}</p>
          </section>
        ))}
      </div>
    </article>
  );
}
